import storage from 'redux-persist/lib/storage';

const isClientSide = typeof window !== 'undefined';

const mainConfig = {
  reduxPersist: {
    key: 'root',
    storage,
    version: 0.4,
    enabled: true,
  },
  isDevEnv: true ,
  isClientSide,
};

export default mainConfig;
